import React from 'react'
import { Popover, OverlayTrigger } from 'react-bootstrap'
import { Icon } from '@LTIDashboard/modules/common'

export function Status({ item }) {
  const textColor = {
    ok: 'text-success',
    error: 'text-danger',
    neutral: 'text-secondary',
  }
  return (
    <div className="d-flex justify-content-start align-items-center">
      <Icon status={item.status} size={1} />
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="bottom"
        overlay={<Popover id=''>{item.helpText}</Popover>}
      >
        <p
          className={`mx-2 my-0 ${
            textColor[item.status]
          } font-weight-light d-inline`}
        >
          {item.text}
        </p>
      </OverlayTrigger>
    </div>
  )
}
const accessPathHelp = { helpText: 'This status determines the setting of the access path for this assessment. This determines from where students can access a assessment. Either this is unrestricted (allowing access from either our website directly or from the LMS) or it is restricted, limiting students to accessing this assesment via their LMS' }
const scoresSyncedHelp = { helpText: 'No student submissions can be found in our system for this assignment.' }
const notInLMSHelp = {
  helpText: 'This means the Canvas Servers do not have record of this item. ',
}
const scorePostedHelp = { helpText: "Checks if at least one of a student's submissions for this assignment has (1) a matching SubmissionLTIOutcome object and (2) if the 'posted_to_lms' attribute on said object is set to 'true'" }
const LtiLaunchHelp = { helpText: 'We have all the information necessary in order to send a score back to the LMS.' }

export const STATUS_VARIANTS = {
  accessPath: {
    restricted: {
      ...accessPathHelp,
      status: 'neutral',
      text: 'Limited to LTI launches',
    },
    unrestricted: {
      ...accessPathHelp,
      status: 'neutral',
      text: 'Unrestricted',
    },
  },
  scoresSynced: {
    ok: {
      ...scoresSyncedHelp,
      title: 'scoresSynced',
      status: 'ok',
      text: 'All Scores Synced',
    },
    error: {
      ...scoresSyncedHelp,
      title: 'scoresSynced',
      status: 'error',
      text: 'Scores Not Synced',
    },
    no_submissions: {
      ...scoresSyncedHelp,
      title: 'scoresSynced',
      status: 'neutral',
      text: 'No Submissions',
    },
  },
  notInLMS: {
    ...notInLMSHelp,
    title: 'notInLMS',
    status: 'neutral',
    text: 'Not in LMS',
  },
  LtiLaunch: {
    ok: {
      ...LtiLaunchHelp,
      title: 'LtiLaunch',
      status: 'ok',
      text: 'LTI Launch Found',
    },
    error: {
      ...LtiLaunchHelp,
      title: 'LtiLaunch',
      status: 'error',
      text: 'No LTI Launch',
    },
  },
  scorePosted: {
    ok: {
      ...scorePostedHelp,
      title: 'scorePosted',
      status: 'ok',
      text: 'Score Posted',
    },
    neutral: {
      ...scorePostedHelp,
      title: 'No Submissions',
      status: 'neutral',
      text: 'No Submissions',

    },
    error: {
      ...scorePostedHelp,
      title: 'scorePosted',
      status: 'error',
      text: 'Score Not Posted',
    },
  },
}
